<template>
  <v-dialog :value="showRecordForm" @input="v => v || HIDE_RECORD_FORM()" max-width="600px" scrollable>
    <v-card>
      <!-- TITLE -->
      <v-card-title class="primary">
        <span class="headline">اضافة مادة للعارض</span>
      </v-card-title>

      <!-- INPUTS -->
      <v-card-text class="pt-5 pb-0">
        <v-btn-toggle dense class="ml-4 float-right" v-model="slideType">
          <v-btn value="article">مقال</v-btn>
          <v-btn value="news">خبر</v-btn>
        </v-btn-toggle>

        <v-autocomplete
          outlined
          dense
          hide-no-data
          no-filter
          clearable
          label="عنوان المادة"
          item-value="id"
          item-text="title"
          prepend-inner-icon="mdi-account"
          :items="autocomplete.list"
          :loading="autocomplete.loading"
          :search-input.sync="autocomplete.searchInput"
          v-model="form.id"
        >
        </v-autocomplete>
      </v-card-text>

      <!-- ACTIONS -->
      <v-card-actions>
        <v-spacer />
        <v-btn
          dark
          elevation="1"
          color="primary"
          :loading="formLoading"
          @click="setSlide(form.id, slideType)"
        >إضافة</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'record-form',


  data: function () {
    return {
      form: {},
      slideType: 'article',
      formLoading: false,

      autocomplete: {
        list: [],
        loading: false,
        searchInput: '',
      }
    }
  },


  computed: {
    ...mapState('carousel', ['showRecordForm'])
  },


  watch: {
    'autocomplete.searchInput'(query) {
      query != '' && this.searchForSlide(this.slideType, query);
    },
  },


  methods: {
    ...mapMutations('carousel', ['HIDE_RECORD_FORM']
    ),

    searchForSlide(slideType, query) {
      if (!query) return;
      this.autocomplete.loading = true;

      this.axios.get(`/admin/${slideType == 'article' ? 'articles' : 'news'}`, { params: { q: query } })
        .then((response) => {
          this.autocomplete.list = response.data.data;
        })
        .finally(() => {
          this.autocomplete.loading = false;
        });
    },

    setSlide(recordId, recordType) {
      this.formLoading = true;

      this.$store.dispatch('carousel/setAsSlide', { recordId, recordType })
        .then((response) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تم إضافة المادة لشرائح العارض بنجاح',
            color: 'success'
          });

          this.$emit('update');
          this.HIDE_RECORD_FORM();
        })
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'خطأ إضافة المادة لشرائح العارض',
            color: 'accent'
          });
        })
        .finally(() => {
          this.formLoading = false;
        });
    }
  }
}
</script>
